<template>
  <div :class="{'d-flex': horizontal, 'justify-content-between': horizontal}">
    <label :id="customLabelId" :class="customLabelClass">
      {{ inputLabel }}
      <i v-if="statusIcon !== ''" class="icon icon-transaction-detail"
        :class="statusIcon">
      </i>
      <i v-if="tooltipLabel"
        class="fa-duotone fa-circle-info cursor text-info tooltipIcon"
        :title="tooltipLabel">
      </i>
    </label>
    <div class="inputParentFormReadGroup" :class="customInputClass">
      <textarea v-if="inputType === 'textarea'" class="form-control inputAccordionForm resize-none" disabled>{{ inputValue }}</textarea>
      <span v-else :id="customInputId" :title="inputValue" class="inputTextFormReadGroup">{{ inputValue }}</span>
      <slot name="afterInput"></slot>
    </div>
    <!--<input class="form-control inputAccordionForm" type="number" disabled="true"
      v-if="inputType === 'number'"
      :id="customInputId"
      :class="customInputClass"
      :value="inputValue">
    </input>
    <input class="form-control inputAccordionForm" type="text" disabled="true"
      v-else
      :id="customInputId"
      :class="customInputClass"
      :value="inputValue">
    </input>-->
    <!-- Le slot par défaut pour afficher certains boutons comme le "View Transfer Order File" -->
    <slot></slot>
  </div>
</template>
<script>
/* @author TLV 24/06/2020
* @brief Component qui affiche les form-groups sur les détails d'une request (accès en lecture)
* @details Ce component a été créé pour permettre de modifier plus rapidement le visuel de ceux-ci si besoin
* @param inputLabel demande la valeur du label
* @param inputValue demande la valeur à afficher dans l'input
*/
export default {
  name: 'formReadGroupLabelInput',
  props: {
    colInputSize: {
      type: Number,
      default: 7
    },
    colLabelSize: {
      type: Number,
      default: 5
    },
    errorId: {
      type: String,
      default: ''
    },
    errorLabel: {
      type: String
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: ''
    },
    inputLabel: {
      type: String
    },
    inputValue: {
      type: String
    },
    labelClass: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: ''
    },
    statusIcon: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    tooltipLabel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customErrorClass: '',
      customErrorId: '',
      customInputClass: '',
      customInputId: '',
      customLabelClass: '',
      customLabelId: ''
    }
  },
  created () {
    this.customErrorClass = this.errorClass
    this.customErrorId = this.errorId

    this.customInputClass = (this.horizontal ? ('col-' + this.colInputSize + ' ') : '') + this.inputClass
    this.customInputId = this.inputId

    this.customLabelClass = this.labelClass
    this.customLabelId = this.labelId

    if (this.horizontal) {
      this.customInputClass += ' col-' + this.colInputSize
      this.customLabelClass += ' col-' + this.colLabelSize
      this.customErrorClass += ' offset-' + this.colLabelSize + ' col-' + this.colInputSize
    }
  }
}
</script>
